import { ref } from 'vue';
import store from '@/store';
import { config } from '@/config.js';

export function useGetEventoDetalle() {
    const evento = ref({});
    const loading = ref(false);
    const error = ref(null);

    const getEvento = async eventoId => {
        if (!eventoId) {
            console.warn('No se proporcionó ID del evento');
            return;
        }

        loading.value = true;
        error.value = null;

        try {
            const data = {
                evento_id: eventoId
            };

            const response = await store.dispatch(
                config.getVuexAlias('back.events.detalle'),
                data
            );

            evento.value = response.data.data;
        } catch (err) {
            console.error('Error al cargar el evento:', err);
            error.value = err.message || 'Error al cargar el evento';
        } finally {
            loading.value = false;
        }
    };

    return {
        evento,
        loading,
        error,
        getEvento
    };
}
